module.exports = __webpack_public_path__ + "static/media/6.a88f11e2.jpeg";